import React from 'react';
import ResponsivePagination from 'react-responsive-pagination';

const customTheme = {
  ul: {
    listStyle: 'none',
    padding: '10px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    display: 'inline-flex',
  },
  li: {
    margin: '0 5px',
  },
  a: {
    padding: '8px 12px',
    color: '#333',
    textDecoration: 'none',
    backgroundColor: '#fff',
    borderRadius: '4px',
    border: '1px solid #ddd',
  },
  'a:hover': {
    backgroundColor: '#007bff',
    color: '#fff',
  },
  '.rrp--active a': {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
  },
};

const Pagination = ({ totalPages, currentPage, handlePagination }) => (
  <div style={{ textAlign: 'center', padding: '20px' }}>
    <ResponsivePagination
      total={totalPages}
      current={currentPage}
      onPageChange={handlePagination}
      theme={customTheme}
    />
  </div>
);

export default Pagination;
